module.exports = function runGetIterableEmailIdFromTheUrl() {
  return new URL(window.location.href).searchParams.get("email_id");
};
